/**
 * Enums for the Wisdom Spirits platform domain model.
 */

/** The physical container format of the THC beverage. */
export enum BeverageFormat {
  Can = 'can',
  Bottle = 'bottle',
  Pouch = 'pouch',
  Box = 'box',
  Draft = 'draft',
}

/** Farm Bill 2018 compliance status for a product. */
export enum FarmBillStatus {
  Compliant = 'compliant',
  NonCompliant = 'non_compliant',
  Unverified = 'unverified',
}

/** Status of an affiliate program/partner. */
export enum ProgramStatus {
  Prospect = 'prospect',
  OutreachSent = 'outreach_sent',
  Active = 'active',
  Paused = 'paused',
  Terminated = 'terminated',
}

/** How commission is calculated for an affiliate relationship. */
export enum CommissionType {
  Percentage = 'percentage',
  CPA = 'CPA',
  RevenueSplit = 'revenue_split',
}

/** The type of purchase link (where the product can be bought). */
export enum LinkType {
  Retailer = 'retailer',
  BrandDirect = 'brand_direct',
  Marketplace = 'marketplace',
}

/** Availability status for a purchase link destination. */
export enum AvailabilityStatus {
  InStock = 'in_stock',
  OutOfStock = 'out_of_stock',
  Unknown = 'unknown',
}

/** Source type for affiliate links and click events. */
export enum SourceType {
  Network = 'network',
  Standalone = 'standalone',
}

/** Source type for click events (extends SourceType with purchase_link). */
export enum ClickSourceType {
  Network = 'network',
  Standalone = 'standalone',
  PurchaseLink = 'purchase_link',
}

/** The user's directional effect vote for a product. */
export enum UpOrDown {
  Up = 'Up',
  Down = 'Down',
  Neutral = 'Neutral',
}

/** Status of a review. */
export enum ReviewStatus {
  Approved = 'approved',
  Flagged = 'flagged',
  Deleted = 'deleted',
}

/** Status of an affiliate link. */
export enum AffiliateLinkStatus {
  Active = 'active',
  Expired = 'expired',
}

/** Status of a purchase link. */
export enum PurchaseLinkStatus {
  Active = 'active',
  Inactive = 'inactive',
}

/** Affiliate network names. */
export enum NetworkName {
  Impact = 'Impact.com',
  ShareASale = 'ShareASale',
}
